/**
 * File overlay.js.
 *
 * Handles the coupon overlay/print functionality
 */
( function() {

    var overlay, button, body, close, input, results, i, len;

    //  Get the toggle button
    button = document.getElementById( 'toggle-coupon' );
	if ( 'undefined' === typeof button ) {
		return;
    }

    //  Get the overlay container
    overlay = document.getElementById( 'coupon-overlay' );
	if ( 'undefined' === typeof overlay ) {
		return;
    }

    //  Get the page body
    body = document.getElementsByTagName( 'body' )[0];
	if ( 'undefined' === typeof overlay ) {
		return;
    }

    //  Get the close button
    close = document.querySelectorAll( '.overlay-close' );
	if ( 'undefined' === typeof close ) {
		return;
    }

    //  Get the print button
    print = document.getElementById( 'print-coupon' );
	if ( 'undefined' === typeof print ) {
		return;
    }

    //  Get the coupon image
    coupon = document.getElementById( 'coupon-image' );
	if ( 'undefined' === typeof coupon ) {
		return;
    }

    //  On coupon button click, show the coupon overlay
    button.onclick = function() {
        overlay.classList.add('open');
        body.classList.add('overlay-open');
        input.focus();
    }

    //  On close button click, hide the coupon overlay
    close.forEach(function(elem) {
        elem.onclick = function() {
            overlay.classList.remove('open');
            body.classList.remove('overlay-open');
        }
    });

    //  On print button click, open the print popup
    print.onclick = function() {
        printImage(coupon.src);
    }

    //  One escape key, hide the coupon overlay
    document.onkeydown = function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        
        if (isEscape) {
            overlay.classList.remove('open');
            body.classList.remove('overlay-open');
        }
    };

    //  Open a popup, place the image, and print it
    function printImage(src) {
        var win = window.open('about:blank', "_new");
        win.document.open();
        win.document.write([
            '<html>',
            '   <head>',
            '   <title>Print Your Coupon</title>',
            '   </head>',
            '   <body onload="window.print()" onafterprint="window.close()">',
            '       <img src="' + src + '"/>',
            '   </body>',
            '</html>'
        ].join(''));
        win.document.close();
    }

    
} )();
